import { IBaseModel } from '../system/BaseModel';

export interface IApplianceCreateUpdateFormFields extends Omit<
  IApplianceCreateRequest,
  'organisationId' | 'heatPumpSettings' | 'modbusSettings'
> {
  heatPumpSettings?: IApplianceHeatPumpSettingsCreateUpdateFormFields;
  modbusSettings?: IApplianceModbusSettingsCreateUpdateFormFields;
}

export interface IApplianceUpdateRequest extends Omit<
  IApplianceCreateRequest,
  'installedDate' | 'organisationId'
> {}

export interface IApplianceCreateRequest extends Omit<
  IAppliance,
  'serviceDue' | 'installedDate' | 'modbusSettings'
> {
  installedDate?: string;
  serviceDue?: string;
  heatPumpSettings?: IApplianceHeatPumpSettings;
  modbusSettings?: IApplianceModbusSettings;
}

export interface IAppliance extends IBaseModel {
  organisationId: string;
  name: string;
  reference?: string;
  deviceId?: string;
  installedDate: string;
  serviceDue: string;
  hardwareTypeId: string;
  hardwareManufacturerId: string;
  hardwareModelId: string;
  modbusSettings: IApplianceModbusSettings;
  setupRequired: boolean;
}

export interface IApplianceModbusSettings {
  protocol: ApplianceModbusProtocol;
  rtuAddress?: number;
  ipAddress?: string;
  port?: number;
}

export interface IApplianceModbusSettingsCreateUpdateFormFields {
  protocol: 'RTU' | 'TCP/IP';
  rtuAddress?: string;
  ipAddress?: string;
  port?: string;
}

export interface IApplianceSelection {
  id: string;
  name: string;
}

export interface IApplianceHeatPumpSettings {
  assumedFlowRate?: number;
  antifreeze?: number;
}

export interface IApplianceHeatPumpSettingsCreateUpdateFormFields {
  assumedFlowRate?: string;
  antifreeze?: string;
}

export interface IHeatPumpAppliance extends IAppliance {
  heatPumpSettings: IApplianceHeatPumpSettings;
}

export enum ApplianceModbusProtocol {
  RTU,
  TCPIP,
}
